export enum Breakpoints {
  mobile = 320,
  tablet = 768,
  desktop = 1024
  // wide = 1440px
}

export enum Margins {
  desktop = 64,
  tablet = 24,
  mobile = 16
}

export enum ZIndex {
  backdrop = 1040,
  modal = 1045,
  overlay = 1050,
  popup = 1055
}
